module.exports = "\n<h2 id=\"logoutMessage\">You have been logged out of the Property Plus</h2>\n\n<span class=\"col-md-12 col-xs-12 mb40\">\n  <p class=\"status_update\">\n    Visit\n    <a routerLink=\"/login\" routerLinkActive=\"active\" title=\"Submit application\">Login</a>\n    page to apply for applications or view\n    <a routerLink=\"/myApplications\" routerLinkActive=\"active\" title=\"View submitted applications\">My applications</a>.\n  </p>\n\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-users/logout/logout.component.html
// module id = ./src/app/manage-users/logout/logout.component.html
// module chunks = main